import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFolderNotificationsSettings, updateAdminSettings } from "src/actionCreators/adminSettingsActionCreators";
import { CompanySettingsName } from "src/Core/Common/Enums";
import { initialCompanyFolderNotificationSettings } from "src/Core/ViewModels/Company/Settings/NotificationsSettings";
import { FolderNotificationConstants } from "src/helper/Constants";
import { ApplicationState } from "src/store";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import CustomToggleSwitch from "src/components/Common/ui/Switch/CustomToggleSwitch";
import Checkbox, { CheckBoxSize } from "src/components/Common/ui/Checkbox";
import { CustomModal } from "src/components/Common/Modal/CustomModal";
import { IFolderNotificationsSettings } from "src/reducers/adminSettingsReducer";


const FolderNotification = () => {
    const [folderNotificationsSettingState, setFolderNotificationsSettingState] = useState(
        initialCompanyFolderNotificationSettings
    );
    const { folderNotificationSettings, isLoading } = useSelector(
        (appState: ApplicationState) => appState.adminSettingsState
    );
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const [pendingNotificationChange, setPendingNotificationChanges] = useState<{ name: string; value: boolean } | null>(null);
    
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchFolderNotificationsSettings());
    }, []);

    useEffect(() => {
        if (folderNotificationSettings) {
            setFolderNotificationsSettingState({
                ...folderNotificationsSettingState,
                ...folderNotificationSettings,
            });
        }
    }, [folderNotificationSettings]);

    const handleFolderNotificationChange = (name: string ,value:any) => {
        setFolderNotificationsSettingState(prevState => {
            const updatedState={
                ...prevState,
                [name]: value,
                isUserAllowedToChangeFolderNotification:
                    name === FolderNotificationConstants.IS_FOLDER_NOTIFICATION_ENABLED && !value
                        ? false
                        : name === FolderNotificationConstants.IS_USER_ALLOWED_TO_CHANGE_FOLDER_NOTIFICATION
                        ? value
                        : prevState.isUserAllowedToChangeFolderNotification,
            };
            return updatedState;
        });

        const payload: IFolderNotificationsSettings = {
            ...folderNotificationsSettingState,
            [name]: value,
        };
        dispatch(updateAdminSettings(CompanySettingsName.FolderNotificationSettings, payload));

    }; 

    const handleAdminToggleChange = (e: any, name: string) => {
        const value = e.target.checked;
        if (!value) {
            setPendingNotificationChanges({ name, value });
            setShowConfirmModal(true);
            return;
        }
        handleFolderNotificationChange(name, value);
    };

    const handleUpdateFolderAdminSettings = () => {
        if (pendingNotificationChange) {
            const { name, value } = pendingNotificationChange;
            handleFolderNotificationChange(name, value);
        }
        setShowConfirmModal(false);
    };

    const handleCheckboxChange = (e: any, name: string) => {
        const value = e.target.checked;
        handleFolderNotificationChange(name, value);
    };

    return (
        <LoadingOverlay>
            <>
                <header>
                    <span>{FolderNotificationConstants.FOLDER_NOTIFICATION_HELPER_TEXT}</span>
                </header>
                <section className="margin-top-10-px">
                    <div className="notification-option-container">
                        <section>
                            <h3 className="heading-black-md text-bold">{FolderNotificationConstants.NEW_MESSAGES}</h3>
                            <span className="notification-helper-text">
                                {FolderNotificationConstants.FOLDER_NOTIFICATION_NEW_MESSAGE_HELPER_TEXT}
                            </span>
                        </section>
                        <div className="settings-label-switch-wrapper toggle-wrapper ">
                            <CustomToggleSwitch
                                label={
                                    FolderNotificationConstants.FOLDER_NOTIFICATION_NOTIFY_FOR_FOLDER_INCOMING_MESSAGES
                                }
                                handleChange={handleAdminToggleChange}
                                name={FolderNotificationConstants.IS_FOLDER_NOTIFICATION_ENABLED}
                                switched={folderNotificationsSettingState.isFolderNotificationEnabled}
                            />
                        </div>
                        {folderNotificationsSettingState.isFolderNotificationEnabled && (
                            <div className="settings-label-switch-wrapper sub-list-settings-item">
                                <Checkbox
                                    id={"checkbox-manage-download-notification"}
                                    value={FolderNotificationConstants.IS_USER_ALLOWED_TO_CHANGE_FOLDER_NOTIFICATION}
                                    className="primary-checkbox"
                                    text={
                                        FolderNotificationConstants.IS_USER_ALLOWED_TO_CHANGE_FOLDER_NOTIFICATION_TEXT
                                    }
                                    size={CheckBoxSize.sm}
                                    checked={folderNotificationsSettingState.isUserAllowedToChangeFolderNotification}
                                    onChange={e =>
                                        handleCheckboxChange(
                                            e,
                                            FolderNotificationConstants.IS_USER_ALLOWED_TO_CHANGE_FOLDER_NOTIFICATION
                                        )
                                    }
                                />
                            </div>
                        )}
                        {showConfirmModal && (
                            <CustomModal
                                show={showConfirmModal}
                                cancelButtonName="No"
                                confirmButtonName="Yes"
                                title={"Confirm Selection"}
                                isConfirmModal={true}
                                className="confirmation-modal"
                                onSubmit={handleUpdateFolderAdminSettings}
                                onHide={() => setShowConfirmModal(false)}
                            >
                                {FolderNotificationConstants.CONFIRM_DISABLE_FOLDER_NOTIFICATIONS}
                            </CustomModal>
                        )}
                    </div>
                </section>
            </>
            <Loader loading={isLoading} />
        </LoadingOverlay>
    );
};

export default FolderNotification;
